/* istanbul ignore file */
import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ADPResourceService } from 'digital-core';
import { UtilityService } from 'src/app/core/services/utility.service';
@Component({
  selector: 'app-offer-table',
  templateUrl: './offer-table.component.html',
  styleUrls: ['./offer-table.component.scss'],
})
export class OfferTableComponent implements OnInit, AfterViewInit {
  @Input() offer: string;
  @Input() contractId: string;
  @Input() userEmail: string;
  @Input() userType: string;
  @Input() usersOnContract: number;

  supportServices: string[];
  buttonUrl: string;
  areSettingsLoaded = false;
  isSPOEEnabled = false;
  isNative = false;

  constructor(
    public matDialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private utilityService: UtilityService,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit() {
    this.isSPOEEnabled  = this.resourceService.isPortalSettingTrue('Global_SPOE_Enabled');
    this.activatedRoute.queryParams.subscribe((params) => {
      this.isNative = (params.isNative && params.isNative.toLowerCase().trim() === 'true') || this.utilityService.isNativeApp;
    });
    const services = this.getSetting(`${this.offer}_SupportServices`);
    if (services) {
      this.supportServices = services.split(';');
      this.buttonUrl = this.getURLSetting(`${this.offer}_URL`);
      if (this.supportServices) {
        this.areSettingsLoaded = true;
      }
    }
  }

  ngAfterViewInit(): void {}

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name).Value;
  }

  getURLSetting(name: string): string {
    return this.resourceService.getPortalSetting(this.resourceService.getPortalSetting(name).Value).Value;
  }

  redirectToUrl(): void {
    window.open(this.buttonUrl, '_blank');
  }

  getViewLabel(item: string) {
    const label = this.resourceService.getViewLabel(item) ?? '';
    return this.resourceService.transformContentData(label);
  }
}
